import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=2062ef58&scoped=true&"
import script from "./extend.vue?vue&type=script&lang=js&"
export * from "./extend.vue?vue&type=script&lang=js&"
import style0 from "./extend.vue?vue&type=style&index=0&id=2062ef58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062ef58",
  null
  
)

export default component.exports